(() => {
  const COPY = {
    title: 'Votre confidentialité',
    body: 'Nous utilisons des cookies pour améliorer votre expérience, mesurer l’audience et personnaliser nos contenus et publicités. Vous pouvez accepter, refuser ou modifier vos préférences à tout moment.',
    preferences: 'Personnaliser'
  };

  const applyCopy = () => {
    const banner = document.querySelector('#shopify-pc__banner, .shopify-pc__banner');
    if (!banner) return false;

    const heading = banner.querySelector(
      '.shopify-pc__banner__heading, [class*="heading"], [class*="title"], h1, h2, h3'
    );
    if (heading && heading.textContent.trim() !== COPY.title) {
      heading.textContent = COPY.title;
    }

    const body = banner.querySelector(
      '.shopify-pc__banner__body, [class*="description"], p'
    );
    if (body) {
      const original = body.textContent || '';
      if (
        original.includes('Shopify') ||
        original.includes('Nous et nos partenaires') ||
        !original.includes(COPY.body)
      ) {
        body.replaceChildren();
        body.append(document.createTextNode(COPY.body + ' '));

        const link = document.createElement('a');
        link.href = '/policies/privacy-policy';
        link.textContent = 'En savoir plus';
        link.setAttribute('aria-label', 'En savoir plus sur notre politique de confidentialité');
        body.append(link);
      }
    }

    const manage = banner.querySelector(
      '.shopify-pc__banner__btn-manage-prefs, [class*="manage"], a[href*="privacy"], button[aria-controls*="prefs"]'
    );
    if (manage) {
      const label = (manage.textContent || '').trim().toLowerCase();
      if (label.includes('préférence') || label.includes('gérer')) {
        manage.textContent = COPY.preferences;
      }
    }

    return true;
  };

  if (applyCopy()) return;

  const observer = new MutationObserver(() => {
    if (applyCopy()) observer.disconnect();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  window.setTimeout(() => observer.disconnect(), 15000);
})();